import React from 'react'
import styled from 'styled-components'
import { Popup } from 'semantic-ui-react'
import './styles.css'

const StyledCard = styled.div`
  width: 60px !important;
  height: 60px !important;

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;

    i {
      font-size: 30px;
    }
  }
`

export default function CustomIconButton() {
  return (
    <Popup
      basic
      hoverable
      pinned
      trigger={
        <StyledCard className="ui card link" id="add-custom-icons">
          <div className="icon">
            <i className="far fa-plus" />
          </div>
        </StyledCard>
      }
      content={
        <div>
          <h3 className="ui dividing header ss-custom-icon-popup-header">
            Custom icon set
          </h3>
          <p>Make your survey even more unique by using a custom icon set.</p>
          <a
            href="https://help.simplesat.io/en/articles/5051375-survey-branding-design#custom-rating-icons"
            target="_blank"
            rel="noreferrer"
            className="ui primary button"
          >
            <i className="book far icon" />
            Learn more
          </a>
        </div>
      }
      className="wide"
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/NewQuestion/CustomIconButton.js